import { render } from "./recordList.vue?vue&type=template&id=79174c9b&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"

import "./recordList.vue?vue&type=style&index=0&id=79174c9b&scoped=true&lang=css"

import exportComponent from "/data/PDBcov/VueJs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79174c9b"]])

export default __exports__